import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { DisableIntegrationOutput } from '../domain/dtos/disable-integration-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class DisableIntegrationById {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(id: string): Promise<DisableIntegrationOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.DELETE,
      url: `${Envs.BFF_WEB_URL}/integrations/${id}`,
    })

    if (response.statusCode === HttpStatusCode.OK && response?.data) {
      return response?.data
    }

    throw new GeneralError()
  }
}
